$(document).ready(function() {
  $(".block_product-frequently-info-inner-checkbox input").on("click", function() {
    var array = [];
    $("input[name='product-frequently']:checked").each(function() {
      array.push($(this).data("price"));
    });

    var sum = 0;
    var checkd = $("input[name='product-frequently']:checked").length;

    for (var i = 0; i < array.length; i++) {
      sum += Number(array[i]);
    }

    $(".block_product-frequently-btn-price").html(formatMoneyWithCurrency(sum, "GBP"));

    if (checkd === 0 || checkd === 1) {
      $(".block_product-frequently-btn-count").html(checkd + " Item");
    } else {
      $(".block_product-frequently-btn-count").html(checkd + " Items");
    }
  });

  $(document).on("click", ".block_product-frequently-info-button", function () {
  var $this = $(this);
  $this.addClass("btn--loading");
  var bulk_product_array = [];
  $("input[name='product-frequently']:checked").each(function (i) {
    if ($(this).val() > 0) {
      bulk_product_array.push({
        id: $(this).attr("value"),
        quantity:$(this).attr("qty")
      });
    }
  });
  let formData = { items: bulk_product_array };
  fetch(`${window.Shopify.routes.root}cart/add.js`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      document.dispatchEvent(new CustomEvent('cart:build'));
      $.getJSON('/cart.js',function(cart){
        if(cart.item_count > 0) {
          $(".cart-link__bubble").addClass('cart-link__bubble--visible');
          $('.cart-link__bubble-num').text(cart.item_count);
        } else {
          $(".cart-link__bubble").removeClass('cart-link__bubble--visible');
          $('.cart-link__bubble-num').text(cart.item_count);
        }
      });
      $this.removeClass("btn--loading");
      setTimeout(function() {
        $("#HeaderCartTrigger")[0].click();
      }, 2000);
    })
    .catch((error) => {
      console.error("Error:", error);
    });
});
});